import { Link as ChakraLink } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  color?: string;
  _hover?: Record<string, any>;
}

export const NavLink = ({ to, children, ...props }: NavLinkProps) => {
  const Component = React.useMemo(
    () => React.forwardRef((linkProps: any, ref) => (
      <RouterLink ref={ref} to={to} {...linkProps} />
    )),
    [to]
  );

  return (
    <ChakraLink
      {...props}
      as={Component}
    >
      {children}
    </ChakraLink>
  );
};